/* sw-diagnostic-core.js — V280 · 30.09.2026
   הלוגיקה של מערכת האבחון (ההתאמה האישית), מתוך snippets/sw-diagnostic-core.liquid.
   הנתונים החיים מהחנות (מחירים, מלאי, תמונות, BRAIN_BASE_URL, SW_SHOP_URL) נשארו מוטבעים בסניפט.
   הקובץ נטען defer — נשמר במטמון הדפדפן ולא נטען מחדש בכל דף. אין לשנות סדר. */
/* אם המשקל שהומלץ אזל — עולים למשקל הזמין הקרוב ביותר כלפי מעלה,
   ורק אם אין כזה יורדים. לעולם לא מחזירים משקל שאינו במלאי. */
function swNearestAvailable(w) {
  w = parseInt(w, 10); if (isNaN(w)) return w;
  if (SHOPIFY_AVAILABLE[w] !== false) return w;
  for (var up = w + 1; up <= 20; up++) if (SHOPIFY_AVAILABLE[up] === true) return up;
  for (var dn = w - 1; dn >= 7;  dn--) if (SHOPIFY_AVAILABLE[dn] === true) return dn;
  return w;
}

var SEV_HE = { mild: 'קל', moderate: 'בינוני', severe: 'חמור', pre_surgery: 'לפני ניתוח' };
var _diagInputs = { condLabel: '', age: 35, roomSqm: 12, severity: 'moderate' };

/* ── HAMBURGER ── */
var hamburger = document.getElementById('sw-hamburger');
var drawer    = document.getElementById('sw-drawer');
if (hamburger) {
  hamburger.addEventListener('click', function() {
    var open = hamburger.classList.toggle('open');
    drawer.classList.toggle('open', open);
    drawer.setAttribute('aria-hidden', !open);
    hamburger.setAttribute('aria-expanded', open);
    document.body.style.overflow = open ? 'hidden' : '';
  });
  drawer.querySelectorAll('a').forEach(function(a) {
    a.addEventListener('click', function() {
      hamburger.classList.remove('open');
      drawer.classList.remove('open');
      drawer.setAttribute('aria-hidden', 'true');
      hamburger.setAttribute('aria-expanded', 'false');
      document.body.style.overflow = '';
    });
  });
}

/* ── ACCORDIONS ── */
function swInitAcc(accId) {
  var acc  = document.getElementById(accId);
  if (!acc) return;
  var btn  = acc.querySelector('.acc-btn');
  var body = acc.querySelector('.acc-body');
  var arr  = acc.querySelector('.acc-arrow');
  btn.addEventListener('click', function() {
    var open = body.classList.toggle('open');
    if (arr) arr.classList.toggle('open', open);
    btn.setAttribute('aria-expanded', open);
  });
}
['sw-acc1','sw-acc2','sw-acc3'].forEach(swInitAcc);
/* Prof Or accordion */
(function() {
  var btn  = document.querySelector('#sw-profor .acc .acc-btn');
  var body = document.getElementById('sw-acc-or-body');
  var arr  = document.getElementById('sw-arr-or');
  if (!btn || !body) return;
  btn.addEventListener('click', function() {
    var open = body.classList.toggle('open');
    if (arr) arr.classList.toggle('open', open);
    btn.setAttribute('aria-expanded', open);
  });
})();

/* ── SEVERITY SEGMENTED ── */
document.querySelectorAll('[data-sev]').forEach(function(btn) {
  btn.addEventListener('click', function() {
    document.querySelectorAll('[data-sev]').forEach(function(b) { b.classList.remove('active'); });
    this.classList.add('active');
    document.getElementById('sw-diag-sev').value = this.dataset.sev;
    /* V279 — "נקבע ניתוח" = שיחה, לא המלצה: הכפתור אומר את זה מראש */
    try { var _sb = document.getElementById('sw-diag-submit'); if (_sb && !_sb.disabled) _sb.textContent = this.dataset.sev === 'pre_surgery' ? 'לתיאום שיחה אישית ←' : 'קבל המלצה למנורה המתאימה לך ←'; } catch (e) {}
  });
});

/* ── MULTI-CONDITION SELECTOR STATE ──────────────────────────
   Max 3 conditions. Parallel API calls → max weight_kg wins.
   Room rule: ≥20 m² → ≥20 kg (enforced client-side as safety net).
   ─────────────────────────────────────────────────────────── */
var _swSelConds = [];   /* [{key, label}, ...] max 3 */
var _swDiagStarted = false; /* GA4: diagnosis_start fired once per session */

/* GA4 condition_key — stable English slug map (language-neutral, cross-platform) */
var _SW_KEY_MAP = {
  'אסתמה':'asthma','COPD':'copd','סינוסיטיס':'sinusitis','נחירות':'snoring',
  'אלרגיה':'allergy','ילדים':'kids','שיעול-כרוני':'chronic_cough','שיעול כרוני':'chronic_cough',
  'אוזניים':'ears','עור':'skin','מעשנים':'smokers','אלרגיות':'allergies',
  'נזלת אלרגית':'allergic_rhinitis','גודש באף':'nasal_congestion','דלקת גרון':'sore_throat',
  'שקדים / אדנואידים':'tonsils_adenoids','נוזלים באוזניים':'ear_fluid','דלקת אוזניים':'ear_infection',
  'אסתמת ילדים':'pediatric_asthma','ברונכיטיס':'bronchitis','ברונכיטיס כרוני':'chronic_bronchitis',
  'ליחה / כיח':'phlegm','קוצר נשימה':'shortness_of_breath','אמפיזמה':'emphysema',
  'אטופיק דרמטיטיס / אקזמה':'eczema','פסוריאזיס':'psoriasis','דום נשימה בשינה':'sleep_apnea',
  'לונג קוביד':'long_covid','פיברומיאלגיה':'fibromyalgia','חרדה ומתח':'anxiety_stress',
  'מניעה / חיזוק חיסון':'immune_support',
  /* V206 — שמות מיושרים לדף הבית + מפתחות חדשים */
  'אלרגיה':'allergies','דלקות גרון':'sore_throat','שקד שלישי ואדנואידים':'tonsils_adenoids','דלקות אוזניים':'ear_infection',
  'ליחה וכיח':'phlegm','COPD / נפחת':'copd','מניעה וחיזוק חיסון':'immune_support',
  'מניעת שפעת':'flu_prevention','מניעת קורונה':'covid_prevention','מניעת וירוס RSV':'rsv_prevention','ילדים ותינוקות':'kids',
  'סטרידור':'stridor','פיברוזיס ריאתי':'pulmonary_fibrosis','ברונכיאקטזיות':'bronchiectasis',
  'החלמה מדלקת ריאות':'pneumonia_recovery','סיסטיק פיברוזיס (CF)':'cf','פוליפים באף':'nasal_polyps','מחיצה עקומה':'deviated_septum',
  'אחרי ניתוח אף / סינוסים':'post_surgery','GVHD / מושתלי מח עצם':'gvhd','מחלות אוטואימוניות / לופוס':'autoimmune'
};
/* condStr: "general" | "מצב:X" | "מצב:X + Y" → English key(s) joined with "+" */
function _swCondKey(condStr) {
  if (!condStr || condStr === 'general') return 'general';
  /* A condition landing page passes its approved attribution context here. */
  if (window._swLandingCondition && condStr === window._swLandingCondition &&
      window._swLandingConditionKey) return window._swLandingConditionKey;
  var stripped = condStr.replace(/^מצב:/, '');
  return stripped.split(' + ').map(function(p){ return _SW_KEY_MAP[p.trim()] || 'other'; }).join('+');
}
/* Preserve condition context when the visitor entered from a condition landing page. */
(function() {
  var p = new URLSearchParams(window.location.search);
  var condition = p.get('condition');
  var key = p.get('condition_key');
  if (condition && key) {
    window._swLandingCondition = 'מצב:' + condition;
    window._swLandingConditionKey = key;
    window._swPageCondition = window._swLandingCondition;
  }
})();
var SW_MAX_CONDS = 3;
var SW_COPD_KEYS = ['copd', 'emphysema', 'pulmonary_fibrosis', 'bronchiectasis']; /* V206 — פיברוזיס ריאתי "כמו COPD בדיוק" (זהר 22.09) · V333 — ברונכיאקטזיות, אותה הוראה בדיוק (זהר 06.10) */
/* V157 · 10.09.2026 · הוראת זהר: "אותו הדבר יש לבצע במחשבון האבחון".
   המפה נכתבה כשהיו שמונה דפי מצב ולכן שלחה מצבים לדף הקרוב ביותר.
   אחרי הבנייה של 09.09 תשע שורות הפכו לקישור שגוי — הן נפתחו, ולכן
   שום בדיקת 404 לא הייתה תופסת אותן:
     דום נשימה→נחירות · אמפיזמה→COPD · קוצר נשימה→COPD · ליחה→שיעול
     דלקת גרון→שיעול · ברונכיטיס(×2)→שיעול · אדנואידים→אוזניים · נוזלים→אוזניים
   fibromyalgia ו-anxiety נשארים בלי כתובת במכוון — הדפים שלהם אינם מפורסמים,
   והקוד מסתיר את הכפתור כשאין קישור. */
var SW_COND_PAGES = {
  'allergies':          '/pages/מנורת-מלח-לאלרגיה',
  'rhinitis':           '/pages/מנורת-מלח-לאלרגיה',
  /* V334 · 06.10.2026 — חמישה דפים שכבר היו חיים באתר ולא היו מחוברים לאבחון (CHECK-0610-COVERAGE-CORRECTION) */
  'postnasal':          '/pages/מנורת-מלח-לנזלת-אחורית',
  'anxiety':            '/pages/מנורת-מלח-להרגעה',
  'fibromyalgia':       '/pages/protocols',
  'cf':                 '/pages/protocols',
  'autoimmune':         '/pages/protocols',
  'sinusitis':          '/pages/מנורת-מלח-לסינוסיטיס',
  'nasal_congestion':   '/pages/מנורת-מלח-לאף-סתום', /* V328 · 05.10.2026 — היה דף הסינוסיטיס */
  'snoring':            '/pages/מנורת-מלח-לנחירות',
  'laryngitis':         '/pages/מנורת-מלח-לדלקת-גרון',
  'adenoids':           '/pages/מנורת-מלח-לשקד-שלישי',
  'ear_fluids':         '/pages/שקד-שלישי-ונוזלים-באוזניים',
  'ear_infection':      '/pages/שקד-שלישי-ונוזלים-באוזניים',
  'tonsils_adult':      '/pages/מנורת-מלח-לשקדים-מבוגרים',
  'asthma':             '/pages/מנורת-מלח-לאסתמה',
  'child_asthma':       '/pages/מנורת-מלח-לאסתמה-בילדים', /* V334 — היה דף הילדים הכללי; קיים דף אסתמת ילדים ייעודי */
  'bronchitis':         '/pages/מנורת-מלח-לברונכיטיס',
  'bronchitis_chronic': '/pages/מנורת-מלח-לברונכיטיס',
  'chronic_cough':      '/pages/מנורת-מלח-לשיעול-כרוני',
  'phlegm':             '/pages/מנורת-מלח-לליחה-וכיח',
  'shortness_breath':   '/pages/מנורת-מלח-לקוצר-נשימה',
  'copd':               '/pages/מנורת-מלח-ל-copd',
  'bronchiectasis':     '/pages/מנורת-מלח-ל-copd', /* V333 · 06.10.2026 — הוראת זהר: "תפנה לדף COPD והאבחון הוא כמו לחולי COPD בדיוק" */
  'emphysema':          '/pages/מנורת-מלח-ל-copd',
  'atopic_dermatitis':  '/pages/מנורת-מלח-לעור',
  'skin_issues':        '/pages/מנורת-מלח-לעור',
  'sleep_apnea':        '/pages/מנורת-מלח-לדום-נשימה-בשינה',
  'long_covid':         '/pages/מנורת-מלח-ללונג-קוביד',
  'immune_boost':       '/pages/מנורת-מלח-למניעה-וחיזוק',
  'pregnancy':          '/pages/מנורת-מלח-בהריון',
  /* V206 — מפתחות חדשים */
  'flu_prevention':     '/pages/מנורת-מלח-למניעה-וחיזוק',
  'covid_prevention':   '/pages/מנורת-מלח-למניעה-וחיזוק',
  'rsv_prevention':     '/pages/מנורת-מלח-למניעה-וחיזוק',
  'kids':               '/pages/מנורת-מלח-לילדים',
  'stridor':            '/pages/מנורת-מלח-לשיעול-כרוני',
  'smokers':            '/pages/מנורת-מלח-למעשנים',
  'pulmonary_fibrosis': '/pages/מנורת-מלח-לפיברוזיס-ריאתי'
};

function _swCondRender() {
  var btn      = document.getElementById('sw-cond-picker-btn');
  var chips    = document.getElementById('sw-cond-chips');
  var btnText  = document.getElementById('sw-cond-btn-text');
  var hint     = document.getElementById('sw-cond-limit-hint');
  var errEl    = document.getElementById('sw-cond-error');
  var atMax    = _swSelConds.length >= SW_MAX_CONDS;

  chips.innerHTML = _swSelConds.map(function(c) {
    return '<span class="sw-cond-chip">' + c.label +
      '<button type="button" class="sw-cond-chip-x" data-key="' + c.key + '" aria-label="הסר">✕</button></span>';
  }).join('');
  chips.querySelectorAll('.sw-cond-chip-x').forEach(function(x) {
    x.addEventListener('click', function(e) {
      e.stopPropagation();
      _swCondToggle(this.dataset.key, '');
    });
  });
  /* V327 · 05.10.2026 — Clarity: טאפים על גוף התגית ("נחירות ✕") לא עשו כלום. טאפ על התגית פותח את רשימת המצבים; ה-✕ עדיין מסיר. */
  chips.querySelectorAll('.sw-cond-chip').forEach(function(ch) {
    ch.style.cursor = 'pointer';
    ch.addEventListener('click', function() { var b = document.getElementById('sw-cond-picker-btn'); if (b) b.click(); });
  });

  btnText.textContent = _swSelConds.length === 0
    ? '— בחר מצב / תסמין —'
    : _swSelConds.length === 1 ? '1 מצב נבחר' : _swSelConds.length + ' מצבים נבחרו';
  btn.classList.toggle('has-sel', _swSelConds.length > 0);
  hint.classList.toggle('show', atMax);

  document.querySelectorAll('.sw-cond-item').forEach(function(item) {
    var isSel = _swSelConds.some(function(c){ return c.key === item.dataset.key; });
    item.classList.toggle('sw-sel', isSel);
    item.classList.toggle('sw-dimmed', atMax && !isSel);
  });

  if (_swSelConds.length > 0) errEl.classList.remove('show');
  _swUpdateSevLabel();
}

/* ── SEVERITY LABEL & ANCHOR — contextual by selected condition ── */
function _swUpdateSevLabel() {
  var labelEl  = document.getElementById('sw-sev-label');
  var anchorEl = document.getElementById('sw-sev-anchor');
  if (!labelEl || !anchorEl) return;
  var keys = _swSelConds.map(function(c){ return c.key; });
  var isKids  = keys.some(function(k){ return /child|adenoid/.test(k); });
  var isSleep = !isKids && keys.some(function(k){ return /snor|sleep_apnea/.test(k); });
  var isNasal = !isKids && !isSleep && keys.some(function(k){ return /allerg|rhinit|sinusit|nasal_cong|laryngit/.test(k); });
  if (isKids) {
    labelEl.textContent  = 'עד כמה זה מפריע לילד?';
    anchorEl.textContent = 'בשינה, בנשימה, ביום-יום — כמה זה בולט?';
  } else if (isSleep) {
    labelEl.textContent  = 'עד כמה זה מפריע לך בחיים?';
    anchorEl.textContent = 'כמה לילות רעים בשבוע? מתעורר באמצע הלילה?';
  } else if (isNasal) {
    labelEl.textContent  = 'עד כמה זה מפריע לך בחיים?';
    anchorEl.textContent = 'בחיי היום-יום, בשינה, בערנות — צריך להחזיק טישו ביד?';
  } else {
    labelEl.textContent  = 'עד כמה זה מפריע לך בחיים?';
    anchorEl.textContent = 'בחיי היום-יום, בשינה, בערנות';
  }
  /* V206 — כפתורי חומרה לפי מצב (הכרעת זהר 22.09): ל-COPD ולפיברוזיס ריאתי החומרה מוגדרת לפי פגיעה בתפקוד הריאות. */
  var isLung = keys.some(function(k){ return k === 'copd' || k === 'pulmonary_fibrosis'; });
  var bm = document.getElementById('sw-sev-mild'), bmo = document.getElementById('sw-sev-moderate'), bs = document.getElementById('sw-sev-severe');
  if (bm && bmo && bs) {
    if (isLung) {
      labelEl.textContent  = 'מה מידת הפגיעה בתפקוד הריאות?';
      anchorEl.textContent = 'לפי בדיקת תפקודי ריאות / דברי הרופא';
      bm.textContent  = 'קל — פגיעה עד 20% בתפקוד הריאות';
      bmo.textContent = 'בינוני — פגיעה של 35–40%';
      bs.textContent  = 'חמור — מעל 41%, הזדקקות לחמצן, קושי תפקודי';
    } else {
      bm.textContent  = 'קל — מפריע לפעמים';
      bmo.textContent = 'בינוני — כמעט כל יום';
      bs.textContent  = 'חמור — משבש לי את החיים / שינה';
    }
  }
  /* V206 — שאלת דלקת ריאות: רק לאסתמת ילדים */
  var pr = document.getElementById('sw-pneumonia-row');
  if (pr) pr.style.display = keys.indexOf('child_asthma') >= 0 ? 'block' : 'none';
}
document.querySelectorAll('[data-pneu]').forEach(function(btn) {
  btn.addEventListener('click', function() {
    document.querySelectorAll('[data-pneu]').forEach(function(b) { b.classList.remove('active'); });
    this.classList.add('active');
    var h = document.getElementById('sw-diag-pneumonia'); if (h) h.value = this.dataset.pneu;
  });
});

function _swCondToggle(key, label) {
  var idx = _swSelConds.findIndex(function(c){ return c.key === key; });
  if (idx >= 0) {
    _swSelConds.splice(idx, 1);
  } else {
    if (_swSelConds.length >= SW_MAX_CONDS) return;
    if (!label) {
      var el = document.querySelector('.sw-cond-item[data-key="' + key + '"]');
      label = el ? el.textContent.replace(/^✓\s*/, '').trim() : key;
    }
    _swSelConds.push({ key: key, label: label });
    /* V81 — בהגעה למקסימום הבחירות הוילון נסגר לבד (הבחירות נשמרות) */
    if (_swSelConds.length >= SW_MAX_CONDS) setTimeout(swClosePanel, 350);
  }
  _swCondRender();
  swMoreAuto();
}
/* V318 — "גיל וגודל חדר" מקופל; V325 · 04.10.2026 — זהר: "ברגע שמסיימים בחירת התסמינים, תפתח מיד את הוילון של הגיל,
   כמות נפשות בחדר וגודל החדר" · ובהבהרה: "הוילון ישאר סגור. הוא יפתח רק כאשר הלקוח יתחיל באבחון ויבחר התסמינים".
   לכן נפתח רק אחרי לחיצה אמיתית של הלקוח על תסמין (isTrusted). סימון מראש מדף מצב / מ-condition_key — לא פותח. */
var SW_KID_KEYS = ['kids','child_asthma','adenoids','ear_fluids','ear_infection','stridor','rsv_prevention'];
var _swUserPicked = false;
document.addEventListener('click', function(e){
  try { if (e.isTrusted && e.target && e.target.closest && e.target.closest('.sw-cond-item')) _swUserPicked = true; } catch (x) {}
}, true); /* capture — רץ לפני הטיפול בלחיצה על הצ'יפ */
function swMoreAuto(){
  try {
    var m = document.getElementById('sw-diag-more'); if (!m || m.open) return;
    if (_swUserPicked && _swSelConds.length) m.open = true;
  } catch (e) {}
}
/* V325 — בסגירת וילון התסמינים: פותחים, מביאים למסך (אם צריך) ומהבהבים */
var _swMoreShown = false;
function swMoreReveal(){
  try {
    if (!_swUserPicked || !_swSelConds.length) return;
    var m = document.getElementById('sw-diag-more'); if (!m) return;
    m.open = true;
    var r = m.getBoundingClientRect(), vh = window.innerHeight || 700;
    if (r.top < 0 || r.top > vh * 0.6) {
      var rm = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      window.scrollTo({ top: Math.max(0, (window.pageYOffset || 0) + r.top - vh * 0.22), behavior: rm ? 'auto' : 'smooth' });
    }
    m.classList.remove('sw-more-pulse'); void m.offsetWidth; m.classList.add('sw-more-pulse');
    setTimeout(function(){ m.classList.remove('sw-more-pulse'); }, 2400);
    if (!_swMoreShown) { _swMoreShown = true; swPreEv('diag_more_revealed', { conditions: _swSelConds.length }); }
  } catch (e) {}
}
/* V325 — נפשות בחדר */
document.querySelectorAll('[data-people]').forEach(function(b){
  b.addEventListener('click', function(){
    var on = this.classList.contains('active');
    document.querySelectorAll('[data-people]').forEach(function(x){ x.classList.remove('active'); });
    var h = document.getElementById('sw-diag-people');
    if (on) { if (h) h.value = ''; return; } /* לחיצה שנייה מבטלת */
    this.classList.add('active'); if (h) h.value = this.dataset.people;
    swPreEv('diag_people_set', { people: this.dataset.people });
  });
});
/* V325 — זנב ההערות לליד: נפשות בחדר + אישור/אי-אישור דיוור (V317). כל בוני ה-notes משתמשים בו. */
window.swNoteTail = function(){
  var a = [];
  if (window._swPeopleNote) a.push(window._swPeopleNote);
  if (window._swConsentNote) a.push(window._swConsentNote);
  return a.join(' · ');
};

/* V81 — סגירת הוילון: כפתור "סיים בחירה", לחיצה בחוץ, Esc, וסגירה אוטומטית ב-3 בחירות. הבחירות נשמרות תמיד (_swSelConds + צ'יפים). */
function swClosePanel(){
  var p=document.getElementById('sw-cond-panel'), b=document.getElementById('sw-cond-picker-btn');
  if(p&&p.classList.contains('open')){ p.classList.remove('open'); if(b){ b.classList.remove('open'); b.setAttribute('aria-expanded','false'); } swMoreReveal(); /* V325 */ }
}
document.getElementById('sw-cond-done').addEventListener('click', function(e){ e.stopPropagation(); swClosePanel(); });
document.addEventListener('click', function(e){
  var p=document.getElementById('sw-cond-panel'), b=document.getElementById('sw-cond-picker-btn');
  if(p&&p.classList.contains('open')&&!p.contains(e.target)&&e.target!==b&&!b.contains(e.target)) swClosePanel();
});
document.addEventListener('keydown', function(e){ if(e.key==='Escape') swClosePanel(); });

/* ═══ V317 · 04.10.2026 — טופס הפרטים שלפני התוצאה ═══ */
var SW_CONSENT_TEXT = 'הנני מאשר/ת קבלת חומר מהחברה בוואטסאפ'; /* V335 · 06.10.2026 — המייל ירד מהשער, האישור מתייחס לוואטסאפ בלבד */
function swPreEv(name, params){ try { window.dataLayer = window.dataLayer || []; var o = { event: name }; for (var k in (params||{})) o[k] = params[k]; window.dataLayer.push(o); if (typeof gtag === 'function') gtag('event', name, params || {}); if (typeof clarity === 'function') clarity('event', name); } catch (e) {} }
/* V372 — נרמול טלפון לפני הבדיקה: 00972→+972 · +9720/9720→+972 · 9 ספרות שמתחילות ב-5 → 0 בהתחלה */
function swNormPhone(v){
  var p = String(v || '').replace(/[^0-9+]/g, '');
  if (p.indexOf('00972') === 0) p = '+972' + p.slice(5);
  p = p.replace(/^\+?9720/, '+972');
  if (/^5\d{8}$/.test(p)) p = '0' + p;
  return p;
}
/* V384 · 21.10.2026 — קישור אבחון אישי מוואטסאפ (?c=<מזהה כרטיס CRM>). הכרעת זהר: "נוריד את השם והטלפון".
   כשיש מזהה תקין: שדות השם והטלפון מוסתרים, והאבחון נשלח למוח עם contact.ghl_contact_id ונכתב לכרטיס הקיים.
   בלי הפרמטר — אין שום שינוי. */
window._swWaCid = (function(){ try { var c = new URLSearchParams(location.search).get('c') || ''; return /^[A-Za-z0-9]{15,40}$/.test(c) ? c : ''; } catch (e) { return ''; } })();
(function(){ if (!window._swWaCid) return; function hide(){ ['sw-pregate','sw-pregate-2'].forEach(function(id){ var el = document.getElementById(id); if (el) el.style.display = 'none'; }); }
  hide(); if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', hide);
  try { if (typeof clarity === 'function') clarity('set', 'diag_variant', 'whatsapp_link_v384'); } catch (e) {} })();
function swPregateOk(){
  var box = document.getElementById('sw-pregate');
  if (window._swWaCid) { /* V384 — מגיע מקישור וואטסאפ: הכרטיס ידוע, אין צורך בשם וטלפון */
    window._swContact = { name: '', phone: '', email: '', preferred_channel: 'whatsapp', ghl_contact_id: window._swWaCid };
    window._swConsentNote = 'הגיע מקישור אבחון בוואטסאפ';
    window._swPregate = true;
    swPreEv('diag_pregate_ok', { source: 'whatsapp-link' });
    return true;
  }
  if (!box) return true; /* אין טופס בדף הזה — התנהגות קודמת */
  var nEl = document.getElementById('sw-pre-name'), pEl = document.getElementById('sw-pre-phone'), eEl = document.getElementById('sw-pre-email'), cEl = document.getElementById('sw-pre-consent'), msg = document.getElementById('sw-pre-msg');
  /* V373 — עותק השדות מעל הכפתור: מאחדים את שני העותקים לפני הבדיקה */
  var n2 = document.getElementById('sw-pre-name-2'), p2 = document.getElementById('sw-pre-phone-2'), g2 = document.getElementById('sw-pregate-2'), msg2 = document.getElementById('sw-pre-msg-2');
  if (nEl && n2) { if (!(nEl.value || '').trim() && (n2.value || '').trim()) nEl.value = n2.value; else if (!(n2.value || '').trim()) n2.value = nEl.value; }
  if (pEl && p2) { if (!(pEl.value || '').trim() && (p2.value || '').trim()) pEl.value = p2.value; else if (!(p2.value || '').trim()) p2.value = pEl.value; }
  var nm = (nEl && nEl.value || '').trim();
  var phRaw = swNormPhone(pEl && pEl.value || ''); /* V372 */
  var em = (eEl && eEl.value || '').trim();
  [nEl, pEl, eEl, n2, p2].forEach(function(x){ if (x) x.classList.remove('sw-pre-bad'); }); /* V373: + n2, p2 */
  var bad = null, why = '';
  if (nm.length < 2) { bad = nEl; why = 'name'; if (msg) msg.textContent = 'כדי לקבל את ההמלצה האישית — נא למלא שם מלא'; }
  else if (!/^0\d{8,9}$|^\+?972\d{8,9}$/.test(phRaw)) /* V372: נייד + קווי, כמו בשער V131b */ { bad = pEl; why = phRaw ? 'phone_invalid' : 'phone'; if (msg) msg.textContent = phRaw ? 'מספר הנייד לא תקין (למשל 0501234567)' : 'כדי לקבל את ההמלצה האישית — נא למלא טלפון נייד'; }
  else if (em && !/^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(em)) { bad = eEl; why = 'email_invalid'; if (msg) msg.textContent = 'כתובת המייל לא תקינה (או השאירו ריק)'; }
  if (bad) {
    if (!nm && !phRaw) why = 'empty'; /* V373 — טופס ריק לגמרי (קודם נרשם כ-name) */
    if (g2) { /* V373 — במקום לזרוק למעלה: פותחים את השדות מעל הכפתור */
      g2.style.display = 'block';
      if (msg2 && msg) msg2.textContent = msg.textContent;
      if (bad === nEl && n2) bad = n2; else if (bad === pEl && p2) bad = p2;
    }
    bad.classList.add('sw-pre-bad');
    try { bad.scrollIntoView({ behavior: 'smooth', block: 'center' }); } catch (e) {}
    try { bad.focus({ preventScroll: true }); } catch (e) { try { bad.focus(); } catch (e2) {} }
    swPreEv('diag_pregate_error', { reason: why });
    try { if (typeof clarity === 'function') clarity('set', 'pregate_reason', why); } catch (e) {} /* V372 */
    return false;
  }
  if (msg) msg.textContent = '';
  if (msg2) msg2.textContent = ''; /* V373 */
  var consent = !!(cEl && cEl.checked);
  var nowIso = new Date().toISOString();
  var ilTime = ''; try { ilTime = new Intl.DateTimeFormat('he-IL', { timeZone: 'Asia/Jerusalem', day: '2-digit', month: '2-digit', year: 'numeric', hour: '2-digit', minute: '2-digit' }).format(new Date()); } catch (e) { ilTime = nowIso; }
  /* שדות איש הקשר נשארים בדיוק במבנה שהמוח מקבל היום (V131b). אישור הדיוור עובר בשדה notes, שהמוח כבר שומר להערת הליד ב-CRM;
     שדה/תגית ייעודיים ב-CRM — בבאטץ' הרפליט הבא (PLAN-V317). */
  window._swContact = { name: nm, phone: phRaw, email: em, preferred_channel: em ? 'both' : 'whatsapp' };
  window._swConsent = { granted: consent, at: consent ? nowIso : '', text: SW_CONSENT_TEXT };
  window._swConsentNote = consent ? ('אישר/ה דיוור בוואטסאפ ("' + SW_CONSENT_TEXT + '", ' + ilTime + ')') : 'לא אישר/ה דיוור שיווקי';
  window._swPregate = true;
  try { localStorage.setItem('sw_pre_contact', JSON.stringify({ name: nm, phone: phRaw, email: em })); } catch (e) {}
  swPreEv('diag_pregate_ok', { marketing_consent: consent ? 'yes' : 'no' });
  if (consent) swPreEv('diag_consent_checked', {});
  try { if (typeof clarity === 'function') clarity('set', 'diag_variant', 'pregate_v317'); } catch (e) {}
  return true;
}
/* מילוי מראש לגולש חוזר (רק בדפדפן שלו) — התיבה לעולם לא מסומנת מראש */
(function(){ try {
  var s = JSON.parse(localStorage.getItem('sw_pre_contact') || 'null'); if (!s) return;
  var n = document.getElementById('sw-pre-name'), p = document.getElementById('sw-pre-phone'), e = document.getElementById('sw-pre-email');
  if (n && !n.value && s.name) n.value = s.name;
  if (p && !p.value && s.phone) p.value = s.phone;
  if (e && !e.value && s.email) { e.value = s.email; var w = document.getElementById('sw-pre-email-wrap'), t = document.getElementById('sw-pre-email-toggle'); if (w) w.style.display = 'block'; if (t) t.style.display = 'none'; }
} catch (e) {} })();

/* V373 — סנכרון חי בין השדות למעלה לעותק שמעל הכפתור */
(function(){ try {
  [['sw-pre-name', 'sw-pre-name-2'], ['sw-pre-phone', 'sw-pre-phone-2']].forEach(function(pr){
    var a = document.getElementById(pr[0]), b = document.getElementById(pr[1]); if (!a || !b) return;
    a.addEventListener('input', function(){ b.value = a.value; });
    b.addEventListener('input', function(){ a.value = b.value; });
    if (a.value && !b.value) b.value = a.value;
  });
} catch (e) {} })();

/* V82 — כפתור השער: אימות שם+טלפון (מייל רשות) → שמירה → המשך אבחון אוטומטי */
document.getElementById('sw-gate-go').addEventListener('click', function(){
  var nm = (document.getElementById('sw-gate-name').value||'').trim();
  var ph = (document.getElementById('sw-gate-phone').value||'').replace(/[^0-9+]/g,'');
  var em = (document.getElementById('sw-gate-email').value||'').trim();
  var msg = document.getElementById('sw-gate-msg');
  /* V131b — הכרעת זהר: לא מכריחים גם טלפון וגם מייל. שם + אחד מהשניים מספיק. */
  var phOk = /^0\d{8,9}$|^\+?972\d{8,9}$/.test(ph);
  var emOk = /^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(em);
  if (nm.length < 2) { if(msg) msg.textContent = 'נא למלא שם מלא'; return; }
  if (!ph && !em) { if(msg) msg.textContent = 'נא להשאיר טלפון או מייל — אחד מהם מספיק'; return; }
  if (ph && !phOk) { if(msg) msg.textContent = 'מספר טלפון לא תקין (למשל 0501234567)'; return; }
  if (em && !emOk) { if(msg) msg.textContent = 'כתובת המייל לא תקינה'; return; }
  if (!phOk && !emOk) { if(msg) msg.textContent = 'נא להשאיר טלפון או מייל תקין'; return; }
  if (msg) msg.textContent = '';
  var _ch = (phOk && emOk) ? 'both' : (phOk ? 'whatsapp' : 'email');
  /* V317 — אם הפרטים כבר נמסרו בטופס שלפני התוצאה, הליד כבר נשלח. כאן זו רק בחירת כוונה
     (ליווי / שיחה): שולחים עדכון לליד, בלי לירות שוב generate_lead/Lead ובלי לאבד את אישור הדיוור. */
  var _isUpdate = !!(window._swPregate && window._swLeadSent);
  window._swContact = { name: nm, phone: phOk ? ph : '', email: emOk ? em : '', preferred_channel: _ch };
  document.getElementById('sw-diag-gate').style.display = 'none';

  /* V131 — לא מריצים את האבחון מחדש. התוצאה כבר על המסך; רק חושפים את הפרטים המלאים,
     שולחים את הליד ויורים את ההמרה הראשית. */
  var _p = window._swLastPayload;
  if (_p) {
    _p.contact = window._swContact;
    var _fi = document.getElementById('sw-res-fullinfo');
    if (_fi) _fi.style.display = 'block';
    swSendLead(_p, true, _isUpdate);
    swFireDiagCompleted();
    var _r = document.getElementById('sw-diag-result');
    try { if (_r && _r.classList.contains('sw-surg')) document.getElementById('sw-res-surg-thanks').style.display = 'block'; } catch (e) {} /* V279 */
    if (_r) _r.scrollIntoView({ behavior: 'smooth', block: 'start' });
  } else {
    document.getElementById('sw-diag-submit').click();
  }
});

/* V258 — מדידת הצעד הבא ממסך התוצאה: וואטסאפ / שיחה / מוצר */
(function(){
  function fire(n){ try { window.dataLayer = window.dataLayer || []; window.dataLayer.push({ event: n, condition_key: (window._swPageCondition || '') });
    if (typeof gtag === 'function') gtag('event', n, { lead_channel: n.replace('diag_result_','') });
    if (typeof clarity === 'function') clarity('event', n); } catch (e) {} }
  [['sw-res-wa','diag_result_whatsapp'],['sw-res-call','diag_result_call'],['sw-res-buy','diag_result_product']].forEach(function(p){
    var el = document.getElementById(p[0]); if (el) el.addEventListener('click', function(){ fire(p[1]); });
  });
})();

/* Picker open/close */
document.getElementById('sw-cond-picker-btn').addEventListener('click', function() {
  var panel  = document.getElementById('sw-cond-panel');
  var isOpen = panel.classList.toggle('open');
  this.classList.toggle('open', isOpen);
  this.setAttribute('aria-expanded', isOpen);
  /* GA4: diagnosis_start — fired once when picker first opens */
  if (isOpen) swBrainWarm(); /* V271 — הלקוח מתחיל אבחון: לוודא שהמוח ער */
  if (isOpen && !_swDiagStarted) {
    _swDiagStarted = true;
    var _startCond    = window._swPageCondition || 'general';
    var _startCondKey = _swCondKey(_startCond);
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ event: 'diagnosis_start', condition: _startCond, condition_key: _startCondKey });
    if (typeof gtag === 'function') {
      gtag('event', 'diagnosis_start', { condition: _startCond, condition_key: _startCondKey });
    }
    try { if (typeof clarity === 'function') clarity('event', 'diagnosis_start'); } catch (e) {} /* V189 */
  }
});

/* Condition item clicks */
document.querySelectorAll('.sw-cond-item').forEach(function(item) {
  item.addEventListener('click', function() {
    var _itemKey   = this.dataset.key;
    var _itemLabel = this.textContent.trim();
    var _isAdding  = !_swSelConds.some(function(c){ return c.key === _itemKey; });
    /* GA4: diagnosis_start fallback — if user clicks item before opening picker */
    if (!_swDiagStarted) {
      _swDiagStarted = true;
      var _startCond    = window._swPageCondition || 'general';
      var _startCondKey = _swCondKey(_startCond);
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({ event: 'diagnosis_start', condition: _startCond, condition_key: _startCondKey });
      if (typeof gtag === 'function') {
        gtag('event', 'diagnosis_start', { condition: _startCond, condition_key: _startCondKey });
      }
      try { if (typeof clarity === 'function') clarity('event', 'diagnosis_start'); } catch (e) {} /* V189 */
    }
    /* GA4: diagnosis_condition_selected — only when adding (not removing) */
    if (_isAdding) {
      var _selCond    = 'מצב:' + _itemLabel;
      var _selCondKey = _swCondKey(_selCond);
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({ event: 'diagnosis_condition_selected', condition: _selCond, condition_key: _selCondKey });
      if (typeof gtag === 'function') {
        gtag('event', 'diagnosis_condition_selected', { condition: _selCond, condition_key: _selCondKey });
      }
    }
    _swCondToggle(_itemKey, _itemLabel);
  });
});

/* Close panel on outside click */
document.addEventListener('click', function(e) {
  var sel = document.getElementById('sw-cond-selector');
  if (sel && !sel.contains(e.target)) {
    document.getElementById('sw-cond-panel').classList.remove('open');
    var pb = document.getElementById('sw-cond-picker-btn');
    pb.classList.remove('open');
    pb.setAttribute('aria-expanded', 'false');
  }
});

/* ── DIAGNOSTIC API ────────────────────────────────────────────
   Calls BRAIN_BASE_URL/api/diagnose for EACH selected condition
   in parallel. Picks the response with the highest weight_kg
   (most demanding condition wins — salt particles serve the
   whole room, so the heaviest need sets the dosage).
   Room rule: ≥20 m² → ≥20 kg, overrides everything.
   ─────────────────────────────────────────────────────────── */
document.getElementById('sw-diag-submit').addEventListener('click', async function() {
  /* Validate — at least one condition */
  /* ═══ V134 · 07.09.2026 — סוף הקצה המת ═══
     נמדד חי: לחיצה על "קבל המלצה" בלי בחירת מצב הציגה הודעה 432px *מעל* הכפתור
     (בנייד — מחוץ למסך), בלי גלילה ובלי סימון גלוי. המשתמש לחץ, לא קרה כלום, ויצא.
     מפת החום של דף הקולקציה: 10 לחיצות על הכפתור מול 2 שהגיעו לשדה השם.
     עכשיו: הודעה גם *ליד* הכפתור, גלילה אל השדה, הדגשה, ואירוע שסופר את זה. */
  var errEl = document.getElementById('sw-cond-error');
  var btnEl = document.getElementById('sw-diag-submit');
  var pickEl = document.getElementById('sw-cond-picker-btn');
  var nearEl = document.getElementById('sw-cond-error-near');
  if (!nearEl && btnEl) {
    nearEl = document.createElement('p');
    nearEl.id = 'sw-cond-error-near';
    nearEl.style.cssText = 'display:none;margin:0 0 .55rem;font-family:Heebo,HeeboFB,sans-serif;font-weight:700;font-size:.95rem;line-height:1.5;text-align:center;direction:rtl';
    nearEl.style.setProperty('color', '#E8632E', 'important');
    btnEl.parentNode.insertBefore(nearEl, btnEl);
  }
  if (_swSelConds.length === 0) {
    if (errEl) errEl.classList.add('show');
    if (nearEl) {
      nearEl.textContent = 'רגע אחד — בחרו קודם מצב או תסמין ☝';
      nearEl.style.display = 'block';
    }
    if (pickEl) {
      try { pickEl.scrollIntoView({ behavior: 'smooth', block: 'center' }); } catch (e) { pickEl.scrollIntoView(); }
      pickEl.style.setProperty('border-color', '#E8632E', 'important');
      pickEl.style.setProperty('box-shadow', '0 0 0 4px rgba(232,99,46,.18)', 'important');
      setTimeout(function () {
        pickEl.style.removeProperty('box-shadow');
        pickEl.style.removeProperty('border-color');
      }, 2600);
      pickEl.focus({ preventScroll: true });
    }
    try {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({ event: 'diagnosis_blocked_no_condition' });
      if (typeof gtag === 'function') gtag('event', 'diagnosis_blocked_no_condition');
      if (typeof clarity === 'function') clarity('set', 'diagnosis_blocked_no_condition', '1');
    } catch (e) {}
    return;
  }
  if (errEl) errEl.classList.remove('show');
  if (nearEl) nearEl.style.display = 'none';

  /* ═══ V387 · 23.10.2026 — זהר: "לחייב מילוי גודל חדר. מאשר בצע" ═══
     קודם: שדה ריק = 16 מ״ר בשקט (12 מתוך 40 אבחונים ב-CRM יצאו 16), וגם 1 מ״ר התקבל.
     V388 · 23.10.2026 — זהר: "שנה בין 8 ל20 מ"ר" ("8 עד 20 בדיוק"). עכשיו: בלי גודל חדר תקין (8–20 מ״ר) אין תוצאה — נפתח האזור, השדה מודגש, והודעה ליד הכפתור. */
  var _sqmEl = document.getElementById('sw-diag-room-sqm');
  if (_sqmEl) {
    var _sqmV = (_sqmEl.value || '').trim();
    var _sqmN = parseInt(_sqmV, 10);
    if (_sqmV === '' || isNaN(_sqmN) || _sqmN < 8 || _sqmN > 20) {
      var _more = document.getElementById('sw-diag-more');
      if (_more) _more.open = true;
      if (nearEl) {
        nearEl.textContent = _sqmV === '' ? 'רגע אחד — נא למלא את גודל החדר במ״ר' : 'גודל החדר לא תקין — נא להקליד בין 8 ל-20 מ״ר';
        nearEl.style.display = 'block';
      }
      try { _sqmEl.scrollIntoView({ behavior: 'smooth', block: 'center' }); } catch (e) { _sqmEl.scrollIntoView(); }
      _sqmEl.style.setProperty('border-color', '#E8632E', 'important');
      _sqmEl.style.setProperty('box-shadow', '0 0 0 4px rgba(232,99,46,.18)', 'important');
      setTimeout(function () { _sqmEl.style.removeProperty('box-shadow'); _sqmEl.style.removeProperty('border-color'); }, 2600);
      _sqmEl.focus({ preventScroll: true });
      try {
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({ event: 'diagnosis_blocked_no_room', room_value: _sqmV });
        if (typeof gtag === 'function') gtag('event', 'diagnosis_blocked_no_room');
        if (typeof clarity === 'function') clarity('set', 'diagnosis_blocked_no_room', '1');
      } catch (e) {}
      return;
    }
  }

  /* ═══ V390 · 25.10.2026 — זהר: "יש תקלה בגיל ... מיד לחפש הבעיה ולתקן" + "כן מאשר" ═══
     קודם: גיל ריק = 35 בשקט, והשדה ישב באזור מקופל (מאז V389 אפשר היה לדלג עליו כליל). עכשיו גיל הוא חובה:
     נשמרות ספרות בלבד; ריק = אין תוצאה — השדה מודגש והודעה ליד הכפתור. 0 תקין (תינוק). */
  var _ageEl = document.getElementById('sw-diag-age');
  if (_ageEl) {
    var _ageV = (_ageEl.value || '').replace(/[^0-9]/g, '');
    var _ageN = parseInt(_ageV, 10);
    if (_ageV === '' || isNaN(_ageN) || _ageN > 120) {
      if (nearEl) {
        nearEl.textContent = _ageV === '' ? 'רגע אחד — נא להקליד את גיל המטופל (לתינוק: 0)' : 'הגיל לא תקין — נא להקליד גיל בשנים';
        nearEl.style.display = 'block';
      }
      try { _ageEl.scrollIntoView({ behavior: 'smooth', block: 'center' }); } catch (e) { _ageEl.scrollIntoView(); }
      _ageEl.style.setProperty('border-color', '#E8632E', 'important');
      _ageEl.style.setProperty('box-shadow', '0 0 0 4px rgba(232,99,46,.18)', 'important');
      setTimeout(function () { _ageEl.style.removeProperty('box-shadow'); _ageEl.style.removeProperty('border-color'); }, 2600);
      _ageEl.focus({ preventScroll: true });
      try {
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({ event: 'diagnosis_blocked_no_age', age_value: (_ageEl.value || '').slice(0, 10) });
        if (typeof gtag === 'function') gtag('event', 'diagnosis_blocked_no_age');
        if (typeof clarity === 'function') clarity('set', 'diagnosis_blocked_no_age', '1');
      } catch (e) {}
      return;
    }
  }

  /* ═══ V317 · 04.10.2026 — שם + טלפון לפני התוצאה (הכרעת זהר) ═══
     רק מי שמילא שם מלא וטלפון נייד תקין מקבל את ההמלצה. תיבת הדיוור רשות ולא מסומנת מראש.
     הפרטים נכנסים ל-window._swContact — ומשם הזרימה הקיימת (V131) שולחת את הליד ויורה diagnosis_completed
     ברגע שהתוצאה מוצגת. */
  if (!swPregateOk()) return;

  /* Close panel */
  document.getElementById('sw-cond-panel').classList.remove('open');
  document.getElementById('sw-cond-picker-btn').classList.remove('open');

  var ageRaw  = (document.getElementById('sw-diag-age').value || '').replace(/[^0-9]/g, ''); /* V390 — ספרות בלבד; ריק נחסם למעלה */
  var age     = ageRaw !== '' ? Math.min(120, Math.max(0, parseInt(ageRaw, 10))) : 35;

  var sqmRaw  = document.getElementById('sw-diag-room-sqm').value.trim();
  var roomSqm = (sqmRaw === '' || isNaN(sqmRaw)) ? 12 : Math.max(1, parseInt(sqmRaw, 10));
  var roomSize = roomSqm >= 20 ? 'large' : roomSqm >= 12 ? 'medium' : 'small';
  document.getElementById('sw-diag-room').value = roomSize;

  var severity = document.getElementById('sw-diag-sev').value || 'moderate';
  /* V206 — דלקת ריאות בעבר (אסתמת ילדים) */
  var _pnEl = document.getElementById('sw-diag-pneumonia');
  var pneumonia = !!(_pnEl && _pnEl.value === 'yes' && _swSelConds.some(function(c){ return c.key === 'child_asthma'; }));

  /* V325 — נפשות בחדר: נאסף להערות הליד בלבד (לא נשלח למוח, לא משנה משקל) */
  var _ppEl = document.getElementById('sw-diag-people');
  var people = (_ppEl && _ppEl.value) || '';
  window._swPeopleNote = people ? ('נפשות בחדר: ' + people) : '';

  _diagInputs = {
    condLabels: _swSelConds.map(function(c){ return c.label; }),
    age: age, roomSqm: roomSqm, severity: severity, pneumonia: pneumonia, people: people
  };

  /* V279 · 30.09.2026 — הכרעת זהר: "נקבע ניתוח - אין אבחון יש שיחה אתנו. בכל המחלות והסימפטומים."
     לא פונים למוח ולא מציגים משקל — מסך שיחה בלבד. */
  if (severity === 'pre_surgery') { swShowSurgeryTalk(); return; }

  /* V131 — השער אינו חוסם עוד את ההמלצה. הוא מוצג אחרי התוצאה (ראו swShowResult). */
  var btn = this;
  btn.disabled = true;
  btn.textContent = '⏳ מעבד נתונים קליניים...';
  /* V305 · 01.10.2026 — תלונת לקוחה: "האבחון נתקע". אסור שכפתור יישאר על "מעבד נתונים" לעולם.
     כל קריאה למוח כבר מוגבלת ל-3 שניות עם גיבוי; כאן רשת ביטחון לכל תקלה אחרת: אם תוך 10 שניות
     לא הוצגה תוצאה, או אם נזרקה שגיאה בהצגה — הכפתור משתחרר ומוצגת הודעה עם וואטסאפ וטלפון. */
  var _swWd = setTimeout(function(){ if (btn.disabled) swDiagRescue(btn, 'watchdog'); }, 10000);
  try {

  /* V271 — גיבוי חכם: מראה את כללי המוח (הכרעות זהר 22.09 + V79/V236). [קל, בינוני, חמור] בק"ג.
     זוגות = 2 מנורות. (V279: "נקבע ניתוח" כבר לא מגיע לכאן — מסך שיחה.) חדר ≥20 מ"ר נאכף אחר כך (רצפת החדר למטה). */
  var SW_FB_SINGLE = {
    pregnancy:[12,14,16], immune_boost:[8,10,12], flu_prevention:[10,12,14], covid_prevention:[15,17,19],
    rsv_prevention:[8,10,14], kids:[10,12,15], chronic_cough:[12,14,16], stridor:[12,14,16],
    tonsils_adult:[15,17,19], sleep_apnea:[16,18,20], smokers:[15,17,19], anxiety:[13,15,17],
    ear_infection:[15,16,17], ear_fluids:[15,16,17], laryngitis:[14,15,16], adenoids:[15,16,17],
    asthma:[15,16,17], child_asthma:[13,14,15], bronchitis:[15,16,17], bronchitis_chronic:[15,16,17],
    sinusitis:[16,17,18], allergies:[16,17,18], rhinitis:[16,17,18], nasal_congestion:[12,14,16],
    phlegm:[14,15,16], snoring:[15,17,18], shortness_breath:[16,17,18], long_covid:[17,18,19],
    /* V279 · 30.09.2026 — הכרעות זהר (טבלת ההכרעות, שאלה 4): פוליפים / מחיצה / אחרי ניתוח אף / החלמה מדלקת ריאות = 16/17/18. ברונכיאקטזיות עברו לזוגות. */
    nasal_polyps:[16,17,18], deviated_septum:[16,17,18],
    post_surgery:[16,17,18], pneumonia_recovery:[16,17,18]
  };
  var SW_FB_PAIR = { copd:[15,17,20], pulmonary_fibrosis:[15,17,20], atopic_dermatitis:[15,17,20],
    skin_issues:[15,17,20], fibromyalgia:[15,17,20],
    /* V279 · 30.09.2026 — הכרעת זהר: אמפיזמה "לאבחן כמו COPD לפי חומרה"; ברונכיאקטזיות "זוג כמו COPD". */
    emphysema:[15,17,20], bronchiectasis:[15,17,20],
    /* V275 · 30.09.2026 — הכרעת זהר: "אוטואימיוני זה לא סמפטום זה קבוצת מחלות ... אבחון כמו COPD בדיוק..זוגות של מנורות בהתאם לחומרה." */
    autoimmune:[15,17,20] };
  /* V278 · 30.09.2026 — הכרעת זהר: "CF מצב קל שלוש 15, בינוני 3 17, קשה 3 של 20 · GVHD: כמו CF". נקבע ניתוח = 3×20. */
  var SW_FB_TRIPLE = { cf:[15,17,20], gvhd:[15,17,20] };
  var swFallbackRec = function(key, sev) {
    var si = sev === 'mild' ? 0 : sev === 'severe' ? 2 : 1;
    if (SW_FB_TRIPLE[key]) return { weight_kg: (sev === 'pre_surgery' ? 20 : SW_FB_TRIPLE[key][si]), lamp_count: 3, dual_lamp: true, confidence_score: 0.85 };
    if (SW_FB_PAIR[key]) {
      var pw = sev === 'pre_surgery' ? 20 : SW_FB_PAIR[key][si];
      return { weight_kg: pw, lamp_count: 2, dual_lamp: true, copd_protocol: SW_COPD_KEYS.indexOf(key) >= 0, confidence_score: 0.85 };
    }
    var row = SW_FB_SINGLE[key] || [15,16,17];
    if (key === 'child_asthma' && pneumonia) row = [15,16,17];
    var w = sev === 'pre_surgery' ? 20 : row[si];
    return { weight_kg: w, lamp_count: 1, confidence_score: 0.85 };
  };

  /* Parallel API calls — one per selected condition. V271: כל קריאה מוגבלת ל-3 שניות, ואז גיבוי. */
  var _swT0 = Date.now();
  var apiCalls = _swSelConds.map(function(c) {
    return swFetchTimeout(BRAIN_BASE_URL + '/api/diagnose', {
      method:  'POST',
      headers: { 'Content-Type': 'application/json' },
      body:    JSON.stringify({ age: age, condition: c.key, room_size: roomSize, severity: severity, room_sqm: roomSqm, pneumonia_history: pneumonia })
    }, Math.min(6000, SW_BRAIN_TIMEOUT_MS + 1000 * Math.max(0, _swSelConds.length - 2)))
    .then(function(r) { if (!r.ok) throw new Error('API ' + r.status); return r.json(); })
    .then(function(d) { d._swSrc = 'brain'; return d; })
    .catch(function(err) {
      return {
        recommendation: swFallbackRec(c.key, severity),
        justification:  'ההמלצה מבוססת על המצב, דרגת החומרה וגודל החדר שסימנת.',
        _swSrc: 'fallback', _swReason: (err && err.swTimeout) ? 'timeout' : 'error'
      };
    })
    .then(function(d) { d._condKey = c.key; return d; });
  });

  var results  = await Promise.all(apiCalls);

  /* V271 — מדידה: זמן תגובה ומקור (brain / fallback / mixed) לכל אבחון */
  try {
    var _swMs = Date.now() - _swT0;
    var _nFb = results.filter(function(d){ return d._swSrc === 'fallback'; }).length;
    var _swSrc = _nFb === 0 ? 'brain' : (_nFb === results.length ? 'fallback' : 'mixed');
    var _swReason = _nFb ? (results.some(function(d){ return d._swReason === 'timeout'; }) ? 'timeout' : 'error') : '';
    var _swBucket = _swMs < 1000 ? 'under_1s' : _swMs < 2000 ? '1_2s' : _swMs < 3000 ? '2_3s' : 'over_3s';
    var _swEv = { diag_source: _swSrc, diag_ms: _swMs, diag_ms_bucket: _swBucket, diag_fallback_reason: _swReason, diag_conditions: results.length };
    window._swLastBrainTiming = _swEv;
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(Object.assign({ event: 'diag_brain' }, _swEv));
    if (typeof gtag === 'function') gtag('event', 'diag_brain', _swEv);
    if (typeof clarity === 'function') { clarity('set', 'diag_source', _swSrc); clarity('set', 'diag_ms_bucket', _swBucket); if (_swSrc !== 'brain') clarity('event', 'diag_fallback'); }
  } catch (e) {}

  /* Pick response with highest weight_kg */
  /* V206 — הכי דורש = לפי משקל כולל (זוג 2×15 גובר על יחידה 18) */
  var _tw = function(d){ var r = d.recommendation || d; return r.total_weight_kg || ((r.lamp_count || 1) * (r.weight_kg || 0)); };
  var bestData = results.reduce(function(best, cur) {
    return _tw(cur) > _tw(best) ? cur : best;
  });

  /* Room floor — client-side safety net */
  var bestRec = bestData.recommendation || bestData;
  if (roomSqm >= 20 && (bestRec.weight_kg || 0) < 20) {
    bestRec.weight_kg = 20; /* V206: לזוג — כל מנורה 20 */
    bestData.justification = (bestData.justification || '') + ' | חדר ≥20 מ״ר — מינימום 20 ק״ג.';
  }

  swShowResult(bestData);
  btn.disabled = false;
  btn.textContent = 'קבל המלצה למנורה המתאימה לך ←';
  try { var _rz = document.getElementById('sw-diag-rescue'); if (_rz) _rz.style.display = 'none'; } catch (e) {}
  } catch (err) {
    swDiagRescue(btn, 'error', err);
  } finally {
    clearTimeout(_swWd);
  }
});

/* V305 · 01.10.2026 — "האבחון לא נתקע לעולם": משחרר את הכפתור ומציג דרך המשך מיידית (וואטסאפ עם המצבים שנבחרו / טלפון). */
function swDiagRescue(btn, why, err){
  try { if (btn) { btn.disabled = false; btn.textContent = 'קבל המלצה למנורה המתאימה לך ←'; } } catch (e) {}
  try {
    var labels = (_swSelConds || []).map(function(c){ return c.label; }).join(', ');
    var wa = 'https://wa.me/972557228865?text=' + encodeURIComponent('שלום, ניסיתי לקבל המלצה באתר' + (labels ? ' עבור: ' + labels : '') + '. אשמח להמלצה על מנורה.');
    var box = document.getElementById('sw-diag-rescue');
    if (!box && btn && btn.parentNode) {
      box = document.createElement('div');
      box.id = 'sw-diag-rescue';
      box.setAttribute('role', 'alert');
      box.style.cssText = 'margin:.7rem 0;padding:.8rem 1rem;border-radius:12px;background:#FDF6EF;border:1.5px solid #F0C4B6;text-align:center;font-family:Heebo,HeeboFB,Arial,sans-serif;direction:rtl;line-height:1.55';
      btn.parentNode.insertBefore(box, btn.nextSibling);
    }
    if (box) {
      box.innerHTML = '<div style="font-weight:800;color:#122E38 !important">לא הצלחנו להציג את ההמלצה כרגע</div>'
        + '<div style="color:#4a453f !important;font-size:.92rem;margin:.25rem 0 .6rem">אפשר ללחוץ שוב על הכפתור, או לקבל המלצה מיד:</div>'
        + '<a href="' + wa + '" target="_blank" rel="noopener" style="display:inline-block;margin:.2rem;padding:.55rem 1rem;border-radius:10px;background:#15803D !important;color:#fff !important;font-weight:800;text-decoration:none">💬 וואטסאפ</a>'
        + '<a href="tel:0502001061" style="display:inline-block;margin:.2rem;padding:.55rem 1rem;border-radius:10px;background:#122E38 !important;color:#fff !important;font-weight:800;text-decoration:none">📞 050-2001061</a>';
      box.style.display = 'block';
    }
  } catch (e) {}
  try {
    var msg = err && err.message ? String(err.message).slice(0, 120) : '';
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ event: 'diag_rescue', diag_rescue_reason: why, diag_rescue_error: msg });
    if (typeof gtag === 'function') gtag('event', 'diag_rescue', { diag_rescue_reason: why, diag_rescue_error: msg });
    if (typeof clarity === 'function') { clarity('event', 'diag_rescue'); clarity('set', 'diag_rescue', why); }
  } catch (e) {}
}


/* ── V78 · 24.08.2026 — סולם שלוש המנורות (רעיון זוהר): X-1 ✗ קטנה מדי · X ✓ המלצת מינימום · X+1 ✓✓ טיפול מהיר וכיסוי גדול יותר. צבעים inline — התמה דורסת classes. ── */
function swLadderNeighbor(w, dir){
  for (var k = w + dir; k >= 7 && k <= 20; k += dir) {
    if (PRODUCT_HANDLES[k] && SHOPIFY_AVAILABLE[k] !== false) return k;
  }
  return null;
}
/* V80 — העברת המצב הנבחר לדף המוצר (?swc=), כדי שהכותרת שם תותאם לבחירת הלקוח (הוראת זוהר) */
function swCondParam(){
  try{
    var lbl = (_swSelConds && _swSelConds.length) ? _swSelConds[0].label : '';
    if (window._swWinLabel) lbl = window._swWinLabel;
    return lbl ? ('?swc=' + encodeURIComponent(lbl)) : '';
  }catch(e){ return ''; }
}
function swLadderImg(kg, op){
  var im = (typeof SHOPIFY_IMAGES !== 'undefined') && SHOPIFY_IMAGES[kg];
  if (!im) return '';
  return '<img src="'+im+'" alt="מנורת מלח '+kg+' ק\u0022ג" loading="lazy" style="width:100%;max-width:150px;height:110px;object-fit:cover;border-radius:10px;margin:.35rem auto;display:block;opacity:'+op+'">';
}
function swLadderCard(kg, kind){
  var price = SHOPIFY_PRICES[kg]; var url = SW_SHOP_URL + '/products/' + PRODUCT_HANDLES[kg] + swCondParam();
  var base = 'flex:1;min-width:150px;max-width:210px;border-radius:14px;padding:1rem .8rem;text-align:center;font-family:Heebo,HeeboFB,Arial,sans-serif;';
  var html = '';
  if (kind === 'small') {
    html = '<div style="'+base+'background:#f6f3ef;border:1.5px solid #ddd5cb;opacity:.85">'
      + '<div style="font-size:1.15rem;color:#b0463c !important;font-weight:900">✗</div>'
      + swLadderImg(kg, .75)
      + '<div style="font-size:1.5rem;font-weight:900;color:#8a8378 !important">'+kg+' ק"ג</div>'
      + '<div style="color:#8a8378 !important;font-size:.85rem;margin:.3rem 0">משקל קטן מדי עבורך</div>'
      + '<div style="color:#8a8378 !important;font-weight:700">'+price.toLocaleString('he-IL')+' ₪</div></div>';
  } else if (kind === 'rec') {
    html = '<a href="'+url+'" style="'+base+'text-decoration:none;display:block;background:#fff;border:2px solid #122E38;box-shadow:0 6px 18px rgba(0,0,0,.08)">'
      + '<div style="font-size:1.15rem;color:#1c7c46 !important;font-weight:900">✓</div>'
      + swLadderImg(kg, 1)
      + '<div style="font-size:1.7rem;font-weight:900;color:#122E38 !important">'+kg+' ק"ג</div>'
      + '<div style="color:#4a453f !important;font-size:.85rem;margin:.3rem 0">ההמלצה עבורך — מינימום</div>'
      + '<div style="color:#122E38 !important;font-weight:800">'+price.toLocaleString('he-IL')+' ₪</div></a>';
  } else {
    html = '<a href="'+url+'" style="'+base+'text-decoration:none;display:block;background:#FDF6EF;border:2.5px solid #E8632E;box-shadow:0 8px 22px rgba(232,99,46,.25);position:relative">'
      + '<div style="font-size:1.15rem;color:#1c7c46 !important;font-weight:900;letter-spacing:2px">✓✓</div>'
      + swLadderImg(kg, 1)
      + '<div style="font-size:1.7rem;font-weight:900;color:#B4471C !important">'+kg+' ק"ג</div>'
      + '<div style="color:#7a2e0a !important;font-size:.85rem;margin:.3rem 0;font-weight:700">טיפול מהיר יותר וכיסוי גדול יותר</div>'
      + '<div style="color:#B4471C !important;font-weight:800">'+price.toLocaleString('he-IL')+' ₪</div></a>';
  }
  return html;
}
function swRenderLadder(kg, isDual, isCopd){
  var box = document.getElementById('sw-ladder'); if (!box) return;
  var _res = document.getElementById('sw-diag-result'); /* V321 — הסולם בראש התוצאה; המספר הגדול מוסתר רק כשהסולם מוצג */
  if (isDual || isCopd || !PRODUCT_HANDLES[kg]) { box.style.display='none'; if (_res) _res.classList.remove('sw-has-ladder'); return; }
  if (_res) _res.classList.add('sw-has-ladder');
  var lo = swLadderNeighbor(kg, -1), hi = swLadderNeighbor(kg, +1);
  var cards = '';
  if (lo) cards += swLadderCard(lo, 'small');
  cards += swLadderCard(kg, 'rec');
  if (hi) cards += swLadderCard(hi, 'big');
  box.innerHTML = '<div style="font-weight:800;color:#122E38 !important;margin:.9rem 0 .5rem;font-family:Heebo,HeeboFB,Arial,sans-serif">שלוש הדרכים שלכם — בחרו את הכיסוי:</div>'
    + '<div style="display:flex;gap:.7rem;justify-content:center;align-items:stretch;flex-wrap:wrap;direction:rtl">'+cards+'</div>';
  box.style.display = 'block';
}

/* V131 — ההמרה הראשית. נורית אך ורק כשנמסרו פרטים, כלומר ליד אמיתי. */
function swFireDiagCompleted(){
  if (window._swDiagConvSent) return; window._swDiagConvSent = true;
  try{
    var c = (window._swLastMeta || {});
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ event: 'diagnosis_completed', condition: c.cond || '', condition_key: c.key || '', severity: c.sev || '' });
    if (typeof gtag === 'function') gtag('event', 'diagnosis_completed', { condition: c.cond || '', condition_key: c.key || '', severity: c.sev || '' });
    if (typeof fbq === 'function') fbq('trackCustom', 'diagnosis_completed', { condition_key: c.key || '', severity: c.sev || '' });
    if (typeof clarity === 'function') { clarity('set', 'diagnosis_completed', '1'); clarity('event', 'diagnosis_completed'); clarity('event', 'lead_submit'); } /* V189 */
  }catch(e){}
}

/* V84 — שליחת ליד עמידה + תור גיבוי */
function swQueueGet(){ try{ return JSON.parse(localStorage.getItem('sw_lead_queue')||'[]'); }catch(e){ return []; } }
function swQueueSet(q){ try{ localStorage.setItem('sw_lead_queue', JSON.stringify(q.slice(-20))); }catch(e){} }
/* V131b — גיבוי דרך טופס יצירת הקשר של שופיפי.
   עד היום כשל מול המוח ברפליט שלח את הליד לתור ב-localStorage של הגולש —
   כלומר הליד נשאר אצלו ולא הגיע לזהר. עכשיו מנסים קודם שופיפי, שתמיד זמין,
   ורק אם גם זה נכשל — לתור. */
function swLeadToShopify(payload){
  try{
    var c = payload.contact || {};
    var conds = (payload.conditions||[]).map(function(x){ return x.label; }).join(' · ');
    var fd = new FormData();
    fd.append('form_type','contact'); fd.append('utf8','✓');
    fd.append('contact[name]', 'ליד אבחון — ' + (c.name||'') );
    if (c.phone) fd.append('contact[phone]', c.phone);
    fd.append('contact[email]', c.email || ('lead-' + String(c.phone||Date.now()).replace(/\D/g,'') + '@saltroom-lead.local'));
    fd.append('contact[body]',
      'שם: ' + (c.name||'-') +
      '\nטלפון: ' + (c.phone||'-') +
      '\nמייל: ' + (c.email||'-') +
      '\nערוץ מועדף: ' + (c.preferred_channel||'-') +
      '\nמצבים: ' + (conds||'-') +
      '\nגיל: ' + (payload.age||'-') + ' · חדר: ' + (payload.room_sqm||'-') + ' מ״ר · חומרה: ' + (payload.severity||'-') +
      '\nהמלצה: ' + (payload.recommended_kg||'-') + ' ק״ג' +
      (payload.notes ? '\nהערות: ' + payload.notes : '') + /* V317 — כולל אישור/אי-אישור דיוור */
      '\nדף: ' + (payload.page||'-'));
    return fetch('/contact', { method:'POST', headers:{'Accept':'application/json'}, body: fd })
      .then(function(r){ if(!r.ok) throw 0; return true; });
  }catch(e){ return Promise.reject(e); }
}

function swSendLead(payload, showUi, silent){
  /* V317 — silent: עדכון כוונה לליד שכבר נשלח (טופס לפני התוצאה). אותה שליחה, בלי לספור שוב generate_lead/Lead. */
  window._swLeadSent = true;
  /* V343 · 07.10.2026 — מזהה אירוע משותף לדפדפן ולשרת, כדי שמטא תזהה שזה אותו Lead ולא תספור פעמיים.
     אותו ערך נשלח ל-/api/diagnosis-lead וגם כ-eventID ב-fbq. בלי זה, CAPI יוצר כפילות. */
  try {
    if (!payload.meta_event_id) {
      payload.meta_event_id = 'lead-' + Date.now() + '-' + Math.random().toString(36).slice(2, 10);
    }
  } catch (e) {}
  /* V271 — תקרה של 15 שניות: אם המוח תקוע, הליד עובר לגיבוי שופיפי ולא נתקע (זמן התעוררות רגיל ~8 ש' נכנס בתקרה) */
  swFetchTimeout(BRAIN_BASE_URL + '/api/diagnosis-lead', { method:'POST', headers:{'Content-Type':'application/json'}, body: JSON.stringify(payload) }, 15000)
    .then(function(r){
      if(!(r.status===200||r.status===201||r.status===202)) throw 0;
      if (silent) return;
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({ event: 'generate_lead' });
      if (typeof gtag === 'function') gtag('event', 'generate_lead', {});
      /* V130 — ליד מהאבחון מדווח גם לפייסבוק */
      /* V343 — eventID זהה לזה שנשלח לשרת, לדה-דופליקציה מול Meta CAPI */
      try { if (typeof fbq === 'function') fbq('track', 'Lead', { content_name: 'diagnostic_core' }, payload.meta_event_id ? { eventID: payload.meta_event_id } : undefined); } catch (e) {}
    })
    .catch(function(){
      /* V131b — לפני שמוותרים: שופיפי. */
      return swLeadToShopify(payload).then(function(){
        if (silent) throw 'handled';
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({ event: 'generate_lead', fallback: 'shopify' });
        if (typeof gtag === 'function') gtag('event', 'generate_lead', { fallback: 'shopify' });
        throw 'handled';
      });
    })
    .catch(function(err){
      if (err === 'handled') return;
      var q=swQueueGet(); payload._queued_at = payload._queued_at || new Date().toISOString(); q.push(payload); swQueueSet(q);
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({ event: 'diagnosis_lead_failed' });
      if (typeof gtag === 'function') gtag('event', 'diagnosis_lead_failed', {});
      if (showUi) {
        var fiL2 = document.getElementById('sw-res-fi-links');
        if (fiL2 && fiL2.innerHTML.indexOf('נשמור ידנית')===-1) fiL2.innerHTML += '<div style="color:#b0463c !important;font-size:.82rem;margin-top:.3rem">הפרטים נשמרו אצלנו וישלחו אוטומטית — או <a href="https://wa.me/972557228865" style="color:#B4471C !important;font-weight:700">כתבו לנו בוואטסאפ</a>.</div>';
      }
    });
}
/* ריקון התור בכל טעינת עמוד האבחון */
(function(){ try{
  var q=swQueueGet(); if(!q.length) return;
  localStorage.removeItem('sw_lead_queue');
  q.forEach(function(p){ swSendLead(p, false); });
}catch(e){} })();

function swShowResult(data) {
  try { document.getElementById('sw-diag-result').classList.remove('sw-surg'); } catch (e) {} /* V279 */
  var rec      = data.recommendation || data;
  var weight   = rec.weight_kg || 15;
  /* V79 · כלל זוהר 24.08 — נחירות: קל 15 · בינוני 17 · חמור 18, בלי תלות בגודל החדר.
     נאכף גם בצד הלקוח עד שהשרת (משימה #91) יעודכן; כשיתעדכן — יסכימו. */
  var _sevNow = document.getElementById('sw-diag-sev') ? document.getElementById('sw-diag-sev').value : 'moderate';
  var _snoreOnly = _swSelConds.length > 0 && _swSelConds.every(function(c){ return c.key === 'snoring'; });
  if (_snoreOnly) {
    weight = ({ mild:15, moderate:17, severe:18, pre_surgery:18 })[_sevNow] || 17;
    rec.dual_lamp = false; rec.dual_system = false;
  }
  /* V236 · 27.09.2026 — הכרעת זהר: "ברונכיטיס ... לתקן לכמו אסטמה מבוגרים. באבחון, זה לא זוגות." (מחליף את כלל הזוג של V234)
     ברונכיטיס / ברונכיטיס כרונית, כשהם לבד (בלי COPD/נפחת/פיברוזיס) → מנורה אחת כמו אסתמה מבוגרים: קל 15 · בינוני 16 · חמור/לפני ניתוח 17.
     נאכף בצד הלקוח (כמו כלל הנחירות V79) עד שהמוח ברפליט יעודכן. */
  var _bronchOnly = _swSelConds.length > 0 && _swSelConds.every(function(c){ return c.key === 'bronchitis' || c.key === 'bronchitis_chronic' || c.key === 'chronic_bronchitis'; });
  if (_bronchOnly) {
    /* V276 · 30.09.2026 — "נקבע ניתוח" = 20 לפי כלל 4 בטבלת ההכרעות (DIAGNOSIS-DECISION-TABLE-2209, "כללים כלליים"), כמו במוח. היה 17 — פרשנות שגויה שלי ב-V236. אישור זהר: "מאשר". */
    weight = ({ mild:15, moderate:16, severe:17, pre_surgery:20 })[_sevNow] || 16;
    rec.lamp_count = 1; rec.dual_lamp = false; rec.dual_system = false; rec.copd_protocol = false;
  }
  /* V390 · 25.10.2026 — זהר: "בתחלואת חורף, שיעול, נזלת בגילאים 0-3 12 קג מינימום 13 קג שדרוג" + "כן, להתעלם" מרצפת החדר.
     גיל 0–3 וכל המצבים שנבחרו מתחלואת חורף → מנורה אחת 12 ק״ג, בלי רצפת חדר 20. מצב נוסף שאינו ברשימה → המנוע הקיים. */
  var _V390_WINTER = ['kids','nasal_congestion','rhinitis','postnasal','chronic_cough','phlegm','flu_prevention','immune_boost'];
  var _ageNow = (_diagInputs && typeof _diagInputs.age === 'number') ? _diagInputs.age : null;
  if (_ageNow !== null && _ageNow <= 3 && _swSelConds.length > 0 &&
      _swSelConds.every(function(c){ return _V390_WINTER.indexOf(c.key) >= 0; })) {
    weight = 12;
    rec.lamp_count = 1; rec.dual_lamp = false; rec.dual_system = false; rec.copd_protocol = false;
  }
  var _wAvail  = swNearestAvailable(weight);
  if (_wAvail !== weight) { weight = _wAvail; }   /* v3 — לא ממליצים על משקל שאזל */
  var lampN    = parseInt(rec.lamp_count, 10) || ((rec.dual_lamp || rec.dual_system) ? 2 : 1); /* V206 — זוג 15/17/20 או שלישייה (CF) */
  var isDual   = lampN > 1;
  /* COPD handle: if winning condition OR any selected condition is COPD/emphysema */
  var winKey   = data._condKey || '';
  /* V80: שמירת תווית המצב המנצח להעברה לדף המוצר */
  window._swWinLabel = '';
  try{ var _wc=_swSelConds.filter(function(c){return c.key===winKey;}); window._swWinLabel = _wc.length?_wc[0].label:(_swSelConds[0]?_swSelConds[0].label:''); }catch(e){}
  var hasCopdSel = _swSelConds.some(function(c){ return SW_COPD_KEYS.indexOf(c.key) >= 0; });
  var isCopd   = rec.copd_protocol || SW_COPD_KEYS.indexOf(winKey) >= 0 || hasCopdSel;
  /* V206 — מחיר זוג = מחירון × 2 (הכרעת זהר 22.09: "אין מחיר מוזל"). 2×15 = 2,700 · 2×17 = 3,500 · 2×20 = 4,500. */
  var unitPrice = SHOPIFY_PRICES[weight] || SHOPIFY_PRICES[15] || 1350;
  var price    = isDual ? (unitPrice * lampN) : unitPrice;
  var disp     = isDual ? (lampN + '×' + weight) : weight;
  var kgNum    = weight;
  /* V207 — זוג → מוצר הזוג בחנות (מחיר ×2). COPD/פיברוזיס זוג 15 → מוצר ה-COPD הקיים (₪2,700, אותו מחיר). שלישייה (CF) → דף המנורה הבודדת. */
  var handle   = (isCopd && isDual && weight === 15)
    ? PRODUCT_HANDLES['copd']
    : (isDual && lampN === 2 && PAIR_HANDLES[kgNum])
      ? PAIR_HANDLES[kgNum]
      : (PRODUCT_HANDLES[kgNum] || PRODUCT_HANDLES[15]);

  document.getElementById('sw-diag-form').style.display   = 'none';
  document.getElementById('sw-diag-submit').style.display = 'none';
  document.getElementById('sw-diag-result').style.display = 'block';

  /* Conversion tracking — נדחף ברגע שה-result panel נהיה גלוי */
  var _diagCond    = _swSelConds.length > 0
    ? 'מצב:' + _swSelConds.map(function(c){ return c.label; }).join(' + ')
    : 'general';
  var _diagCondKey = _swCondKey(_diagCond);
  window.dataLayer = window.dataLayer || [];
  var _diagSevVal = document.getElementById('sw-diag-sev') ? document.getElementById('sw-diag-sev').value : 'moderate';
  /* ═══ V131 · 07.09.2026 — הפרדת האותות ═══
     עד V130 האירוע diagnosis_completed נורה כשהתוצאה הוצגה — אבל התוצאה הוצגה רק
     אחרי מסירת טלפון, ולכן הוא סימן ליד אמיתי. עכשיו התוצאה מוצגת לכולם, ולכן:
       diagnosis_result_shown  → הוצגה המלצה. אות תצפית. **לא** המרה.
       diagnosis_completed     → נמסרו פרטים = ליד. נשאר ההמרה הראשית שמזינה בידינג.
     בלי ההפרדה הזו נפח ההמרות היה קופץ פי ~7 בן לילה והבידינג היה לומד אות חלש. */
  window._swLastMeta = { cond: _diagCond, key: _diagCondKey, sev: _diagSevVal };
  window.dataLayer.push({ event: 'diagnosis_result_shown', condition: _diagCond, condition_key: _diagCondKey, severity: _diagSevVal });
  if (typeof gtag === 'function') {
    gtag('event', 'diagnosis_result_shown', { condition: _diagCond, condition_key: _diagCondKey, severity: _diagSevVal });
  }
  try {
    if (typeof fbq === 'function') fbq('trackCustom', 'diagnosis_result_shown', { condition_key: _diagCondKey, severity: _diagSevVal });
    if (typeof clarity === 'function') { clarity('set', 'diagnosis_result_shown', '1'); clarity('event', 'diagnosis_result_shown'); } /* V189 */
  } catch (e) {}
  /* GA4: pre_surgery_intent — event נפרד בחומרה 4 */
  if (_diagSevVal === 'pre_surgery' && typeof gtag === 'function') {
    gtag('event', 'pre_surgery_intent', {
      condition: _diagCond,
      condition_key: _diagCondKey,
      event_category: 'diagnostic',
      event_label: 'לפני_ניתוח'
    });
  }
  /* CRM — store severity in localStorage for lead creation flow */
  try { localStorage.setItem('sw_last_severity', _diagSevVal); } catch(e) {}

  document.getElementById('sw-res-kg').textContent    = disp + ' ק"ג';
  document.getElementById('sw-res-label').textContent = isDual ? (lampN === 3 ? 'שלוש המנורות המומלצות עבורך' : 'זוג המנורות המומלץ עבורך — בהתאמה אישית') : 'המנורה המומלצת עבורך';
  var justText = data.justification || rec.justification || rec.research_basis || '';
  /* V211 — הוראת זהר 22.09: "זוג מנורות בהתאמה אישית — זה יכול להיות רק בחדר שינה או חדר שינה וסלון — תלוי במצבו של המטופל, ועל פי ההדרכה שלנו." לא מציגים את המיקום שהמוח מחזיר. */
  if (isDual) justText += (justText ? ' | ' : '') + (lampN === 3 ? 'שלוש מנורות של ' : 'זוג מנורות של ') + weight + ' ק"ג בהתאמה אישית — שתיהן בחדר השינה, או חדר שינה וסלון, לפי מצבך ועל פי ההדרכה שלנו.';
  /* pre_surgery — הוסף הערת ליווי צמוד (ללא ייעוץ רפואי!) */
  if (_diagSevVal === 'pre_surgery' && data.pre_surgery_note) {
    justText += (justText ? ' | ' : '') + data.pre_surgery_note;
  }
  document.getElementById('sw-res-just').textContent = justText;
  document.getElementById('sw-res-price').textContent = price.toLocaleString('he-IL') + ' ₪';

  var inp      = _diagInputs;
  var sevHe    = SEV_HE[inp.severity] || 'בינוני';
  var condStr  = (inp.condLabels || []).join(' + ');
  document.getElementById('sw-res-personal').textContent =
    'עבור ' + condStr + ' · גיל ' + inp.age + ' · חדר ' + inp.roomSqm + ' מ״ר · חומרה ' + sevHe;
  /* V258 — וואטסאפ עם ההמלצה (נוסח זהר: "שלום רפאלה") */
  try {
    var _recTxt = (isDual ? (lampN === 3 ? 'שלוש מנורות של ' : 'זוג מנורות של ') : 'מנורה של ') + weight + ' ק"ג';
    var _waMsg = 'שלום רפאלה, עשיתי אבחון באתר: ' + (condStr || 'מצב כללי') + ', חומרה ' + sevHe + ', חדר ' + inp.roomSqm + ' מ"ר. המליצו לי על ' + _recTxt + '. אשמח לשיחה.';
    var _wa = document.getElementById('sw-res-wa');
    if (_wa) _wa.href = 'https://wa.me/972557228865?text=' + encodeURIComponent(_waMsg);
  } catch (e) {}

  /* V82 — הבחירה המלאה במסך התוצאות (הוראת זוהר) + רישום מיידי לשרת/CRM */
  try {
    var fiB = document.getElementById('sw-res-fi-body');
    var fiL = document.getElementById('sw-res-fi-links');
    var fiBox = document.getElementById('sw-res-fullinfo');
    if (fiB && fiBox) {
      var condNames = (inp.condLabels||[]).join(' · ');
      fiB.innerHTML = '<b>מצבים שנבחרו:</b> ' + condNames
        + '<br><b>גיל:</b> ' + inp.age + ' · <b>גודל חדר:</b> ' + inp.roomSqm + ' מ״ר · <b>חומרה:</b> ' + sevHe
        + '<br><b>ההמלצה:</b> ' + disp + ' ק"ג' + (isDual ? ' (' + lampN + ' מנורות)' : '') + (window._swWinLabel && (inp.condLabels||[]).length > 1 ? ' — חושבה לפי המצב הדורש ביותר: <b>' + window._swWinLabel + '</b>' : '');
      var lk = '';
      _swSelConds.forEach(function(c){
        var u = SW_COND_PAGES[c.key];
        if (u) lk += '<a href="' + u + '" style="color:#B4471C !important;font-weight:700;text-decoration:none;margin-inline-start:.7rem">קראו על ' + c.label + ' ←</a>';
      });
      if (fiL) fiL.innerHTML = lk;
      fiBox.style.display = 'block';
    }
    /* V84 — רישום עמיד (הוראת זוהר: "האבחון לא נרשם — תבנה מעקב אצלנו"):
       (1) payload בלי display (ולידציית השרת הנוכחית) — הליד נשמר ל-DB גם כש-CRM נופל.
       (2) תור גיבוי ב-localStorage: כשל שליחה → נשמר ונשלח שוב בביקור הבא. אפס אובדן.
       (3) אירוע GA4 diagnosis_lead_failed (בלי PII) — ניטור נפילות. */
    var _diagPayload = {
      contact: window._swContact || null,
      conditions: _swSelConds.map(function(c){ return { key: c.key, label: c.label }; }),
      age: inp.age, room_sqm: inp.roomSqm, severity: inp.severity,
      recommended_kg: kgNum, lamp_count: lampN, pneumonia_history: !!inp.pneumonia, win_condition: window._swWinLabel || '',
      source: (window._swWaCid ? 'whatsapp-link' : 'diagnostic-widget'), page: location.pathname,
      attribution: (function(){ try{ return {
        first: JSON.parse(localStorage.getItem('sw_attr_first')||'null'),
        last:  JSON.parse(localStorage.getItem('sw_attr_last')||'null'),
        meta_cookies: (typeof window._swMetaCookies === 'function') ? window._swMetaCookies() : null,
        current_url: location.href.slice(0,300)
      }; }catch(e){ return null; } })()
    };
    /* V131 — הליד נשלח רק כשיש פרטים. בלי פרטים: מציגים את השער מתחת לתוצאה. */
    if (window.swNoteTail()) _diagPayload.notes = window.swNoteTail(); /* V317 · V325 */
    window._swLastPayload = _diagPayload;
    if (window._swContact) {
      _diagPayload.contact = window._swContact;
      if (fiBox) fiBox.style.display = 'block';
      swSendLead(_diagPayload, true);
      swFireDiagCompleted();
      /* V317 — הפרטים נמסרו לפני התוצאה: השער נשאר רק לבחירת הכוונה (ליווי עד הצלחה / שיחה עם נציג),
         עם הפרטים ממולאים ומוסתרים — אותה ולידציה ואותה שליחה של V314, בלחיצה אחת. */
      if (window._swPregate) swGateKnown();
    } else {
      if (fiBox) fiBox.style.display = 'none';
      var _g = document.getElementById('sw-diag-gate');
      if (_g) _g.style.display = 'block';
      /* V131 — עד היום לא היה שום אירוע כשהשער נפתח, ולכן אי אפשר היה לדעת
         כמה אנשים בכלל הגיעו אליו. בלי זה הפער 39→5 היה ניחוש. מעכשיו נמדד. */
      try {
        window.dataLayer.push({ event: 'diagnosis_gate_shown', condition_key: _diagCondKey, severity: _diagSevVal });
        if (typeof gtag === 'function') gtag('event', 'diagnosis_gate_shown', { condition_key: _diagCondKey, severity: _diagSevVal });
        if (typeof clarity === 'function') { clarity('set', 'diagnosis_gate_shown', '1'); clarity('event', 'diagnosis_gate_shown'); } /* V189 */
      } catch (e) {}
    }
  } catch(e) {}

  /* CTA → real Shopify product page */
  document.getElementById('sw-res-buy').href = SW_SHOP_URL + '/products/' + handle + swCondParam();
  document.getElementById('sw-res-buy').textContent = isDual ? (lampN === 3 ? 'לשלוש המנורות המומלצות ←' : 'לזוג המנורות המומלץ ←') : 'למנורה המומלצת ←'; /* V207 */
  swRenderLadder(kgNum, isDual, isCopd);
  /* V323 — דף השירות האישי (assets/sw-service-v323.js): למה, תשלומים, סיכון, "נציג יחזור אליי", והשאלות מתוך דף המצב */
  try { if (typeof window.swSvcRender === 'function') window.swSvcRender({ kg: kgNum, dual: isDual, lamps: lampN, winKey: winKey, winLabel: window._swWinLabel || '', conds: _swSelConds.slice(), sev: _diagSevVal, room: inp && inp.roomSqm, people: inp && inp.people, buy: document.getElementById('sw-res-buy').href, wa: (document.getElementById('sw-res-wa') || {}).href }); } catch (e) {}

  /* Condition landing page link */
  var landingUrl = data.landing_url || SW_COND_PAGES[winKey] || '';
  var condLink = document.getElementById('sw-res-cond');
  if (condLink) {
    if (landingUrl) { condLink.href = landingUrl; condLink.style.display = 'inline-block'; }
    else            { condLink.style.display = 'none'; }
  }

  /* V267 · 29.09.2026 — נייד: block:'center' על תוצאה גבוהה (עם סולם המשקלים) השאיר את ראש התוצאה, ההמלצה וכפתורי וואטסאפ/שיחה מעל המסך. המבקר ראה רק את הסולם. נבדק ב-375px: הכותרת ב-853px מעל המסך, 0 לחיצות וואטסאפ/שיחה ב-7 ימים. עכשיו גוללים לראש התוצאה, עם מרווח לכותרת הדביקה. */
  /* V268 · 29.09.2026 — בבדיקה חיה אחרי V267: window.scrollTo עם behavior:'smooth' לא זז בכלל בדפדפן הבדיקה (instant כן זז). חוזרים ל-scrollIntoView, שעבד תמיד, אבל עם block:'start' על כותרת התוצאה ו-scroll-margin-top של 90px לכותרת הדביקה. אחרי 900ms, אם הכותרת עדיין מחוץ למסך, קופצים אליה מיד. */
  (function(){ var _t = document.getElementById('sw-res-label') || document.getElementById('sw-diag-result');
    try { _t.style.scrollMarginTop = '90px'; _t.scrollIntoView({ behavior: 'smooth', block: 'start' }); } catch (e) { try { _t.scrollIntoView(true); } catch (e2) {} }
    setTimeout(function(){ try { var _r = _t.getBoundingClientRect(); var _vh = window.innerHeight || 800; if (_r.top < 0 || _r.top > _vh * 0.5) { var _y = _r.top + (window.pageYOffset || document.documentElement.scrollTop) - 90; window.scrollTo(0, Math.max(0, _y)); } } catch (e) {} }, 900);
  })();
}

/* V317 — השער במצב "פרטים ידועים" */
function swGateKnown(){
  try {
    if (window._swWaCid) return; /* V384 — הלקוח כבר בשיחת וואטסאפ איתנו; השער (שם+טלפון) לא רלוונטי */
    var g = document.getElementById('sw-diag-gate'), c = window._swContact || {};
    if (!g) return;
    var n = document.getElementById('sw-gate-name'), p = document.getElementById('sw-gate-phone'), e = document.getElementById('sw-gate-email');
    if (n) n.value = c.name || ''; if (p) p.value = c.phone || ''; if (e) e.value = c.email || '';
    g.classList.add('sw-gate-known');
    g.style.display = 'block';
    swPreEv('diag_intent_shown', {});
  } catch (e) {}
}

/* V279 · 30.09.2026 — "נקבע ניתוח" = שיחה איתנו, בלי המלצת משקל (הכרעת זהר, בכל המצבים והסימפטומים).
   אותו מסך תוצאה במצב sw-surg: מוסתרים משקל/מחיר/סולם/מוצר; נשארים וואטסאפ, טלפון והשער (ליד לשיחה). */
function swShowSurgeryTalk() {
  try { if (typeof window.swSvcHide === 'function') window.swSvcHide(); } catch (e) {} /* V323 */
  var box = document.getElementById('sw-diag-result');
  box.classList.add('sw-surg');
  document.getElementById('sw-diag-form').style.display   = 'none';
  document.getElementById('sw-diag-submit').style.display = 'none';
  box.style.display = 'block';
  var inp = _diagInputs || {};
  var condStr = (inp.condLabels || []).join(' + ');
  var _diagCond = _swSelConds.length > 0 ? 'מצב:' + _swSelConds.map(function(c){ return c.label; }).join(' + ') : 'general';
  var _diagCondKey = _swCondKey(_diagCond);
  window._swWinLabel = _swSelConds[0] ? _swSelConds[0].label : '';
  window._swLastMeta = { cond: _diagCond, key: _diagCondKey, sev: 'pre_surgery' };
  document.getElementById('sw-res-label').textContent = 'לפני ניתוח — מתאימים את הטיפול בשיחה אישית';
  document.getElementById('sw-res-personal').textContent = 'עבור ' + (condStr || 'מצב כללי') + ' · גיל ' + inp.age + ' · חדר ' + inp.roomSqm + ' מ״ר · נקבע ניתוח';
  try {
    var _waMsg = 'שלום רפאלה, עשיתי אבחון באתר: ' + (condStr || 'מצב כללי') + '. נקבע לי ניתוח, ואשמח לשיחה על התאמת הטיפול.';
    var _wa = document.getElementById('sw-res-wa');
    if (_wa) _wa.href = 'https://wa.me/972557228865?text=' + encodeURIComponent(_waMsg);
  } catch (e) {}
  try {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ event: 'pre_surgery_talk_shown', condition: _diagCond, condition_key: _diagCondKey, severity: 'pre_surgery' });
    if (typeof gtag === 'function') {
      gtag('event', 'pre_surgery_intent', { condition: _diagCond, condition_key: _diagCondKey, event_category: 'diagnostic', event_label: 'לפני_ניתוח' });
      gtag('event', 'pre_surgery_talk_shown', { condition_key: _diagCondKey });
    }
    if (typeof clarity === 'function') { clarity('set', 'diag_pre_surgery', '1'); clarity('event', 'pre_surgery_talk_shown'); }
    localStorage.setItem('sw_last_severity', 'pre_surgery');
  } catch (e) {}
  /* ליד לשיחה: בלי משקל (recommended_kg 0, lamp_count 0) — המוח מסמן "לפני ניתוח — שיחה" */
  var _p = {
    contact: window._swContact || null,
    conditions: _swSelConds.map(function(c){ return { key: c.key, label: c.label }; }),
    age: inp.age, room_sqm: inp.roomSqm, severity: 'pre_surgery',
    recommended_kg: 0, lamp_count: 0, consult_only: true, consult_reason: 'pre_surgery',
    pneumonia_history: !!inp.pneumonia, win_condition: window._swWinLabel || '',
    source: (window._swWaCid ? 'whatsapp-link' : 'diagnostic-widget'), page: location.pathname,
    attribution: (function(){ try{ return {
      first: JSON.parse(localStorage.getItem('sw_attr_first')||'null'),
      last:  JSON.parse(localStorage.getItem('sw_attr_last')||'null'),
      meta_cookies: (typeof window._swMetaCookies === 'function') ? window._swMetaCookies() : null,
      current_url: location.href.slice(0,300)
    }; }catch(e){ return null; } })()
  };
  if (window.swNoteTail()) _p.notes = window.swNoteTail(); /* V317 · V325 */
  window._swLastPayload = _p;
  var _g = document.getElementById('sw-diag-gate');
  try { document.getElementById('sw-res-surg-thanks').style.display = window._swContact ? 'block' : 'none'; } catch (e) {}
  if (window._swContact) {
    if (_g) _g.style.display = 'none';
    swSendLead(_p, false);
    swFireDiagCompleted();
  } else if (_g) {
    _g.style.display = 'block';
    try {
      window.dataLayer.push({ event: 'diagnosis_gate_shown', condition_key: _diagCondKey, severity: 'pre_surgery' });
      if (typeof gtag === 'function') gtag('event', 'diagnosis_gate_shown', { condition_key: _diagCondKey, severity: 'pre_surgery' });
    } catch (e) {}
  }
  var _cl = document.getElementById('sw-res-cond');
  var _u = _swSelConds[0] ? SW_COND_PAGES[_swSelConds[0].key] : '';
  if (_cl) { if (_u) { _cl.href = _u; _cl.style.display = 'inline-block'; } else { _cl.style.display = 'none'; } }
  try { var _t = document.getElementById('sw-res-label'); _t.style.scrollMarginTop = '90px'; _t.scrollIntoView({ behavior: 'smooth', block: 'start' }); } catch (e) {}
}

document.getElementById('sw-res-reset').addEventListener('click', function() {
  try { document.getElementById('sw-diag-result').classList.remove('sw-surg'); } catch (e) {} /* V279 */
  document.getElementById('sw-diag-form').style.display   = 'block';
  document.getElementById('sw-diag-submit').style.display = 'block';
  document.getElementById('sw-diag-result').style.display = 'none';
  /* Reset selections */
  try { if (typeof window.swSvcHide === 'function') window.swSvcHide(); } catch (e) {} /* V323 */
  _swSelConds = [];
  _swDiagStarted = false; /* GA4: allow diagnosis_start to fire again on next session */
  _swCondRender();
  try { var _pr = document.getElementById('sw-pneumonia-row'); if (_pr) _pr.style.display = 'none'; } catch(e) {}
});

/* ── v3 · 21.08.2026 — סימון אוטומטי של המצב מפרמטר ה-URL ──
   מודעת מצב שנוחתת עם ?condition_key=sinusitis תגיע לאבחון כשהצ'יפ כבר מסומן.
   עד היום הפרמטר נקרא למעקב בלבד ולא השפיע על הממשק.
   מבוצע כלחיצה אמיתית על אותו כפתור, כדי שכל הלוגיקה והמעקב הקיימים ירוצו כרגיל. */
(function() {
  try {
    var params = new URLSearchParams(window.location.search);
    var raw = params.get('condition_key') || params.get('condition');
    if (!raw) return;
    var keys = raw.split(',').map(function(k){ return k.trim().toLowerCase(); }).filter(Boolean).slice(0, SW_MAX_CONDS);
    if (!keys.length) return;
    var apply = function() {
      var applied = 0;
      keys.forEach(function(k) {
        var btn = document.querySelector('.sw-cond-item[data-key="' + k.replace(/"/g,'') + '"]');
        if (btn && !btn.classList.contains('sw-sel') && !btn.classList.contains('sw-dimmed')) {
          btn.click(); applied++;
        }
      });
      if (applied) {
        var box = document.getElementById('sw-diag-form');
        if (box && box.scrollIntoView) box.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }
    };
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', apply);
    else setTimeout(apply, 0);
  } catch (e) { /* לעולם לא לשבור את האבחון בגלל פרמטר ב-URL */ }
})();

/* ═══ V210 · 23.09.2026 — טקסט ההסבר בשער האבחון נלחץ במקום כפתור השליחה ═══
   אישור זהר: "מאשר" (23.09), על בסיס PLAN-V210-click-the-promise-not-the-button-2309.
   הראיה: הצ'קאאוט הנטוש 46691807658211. בהקלטת קלריטי, ב-13:18 של הסשן, הגולש מילא
   שם/טלפון/מייל בשער ואז לחץ על ה-div של "נשלח לכם בוואטסאפ או במייל…" — טקסט הסבר,
   לא כפתור. שלוש שניות אחר כך עזב את הדף. אין לו ליד בטבלה, אין מייל גיבוי, אין CRM,
   ו-diagnosis_completed לא נרשם. באותו חלון של 3 ימים: 6 התחילו אבחון, 5 הגיעו לשער, 0 השלימו.
   השינוי: לחיצה בתוך השער על מה שאינו שדה/כפתור/קישור ממקדת את השדה הראשון שריק
   וגוללת את כפתור השליחה למרכז המסך. **אינה שולחת כלום** — כדי שלחיצה מקרית על טקסט
   לא תייצר ליד חלקי. אף מילה בשער לא שונתה, והכפתור עצמו לא נגעו בו.
   להחזרה: למחוק את בלוק ה-script הזה. */
(function () {
  var gate = document.getElementById('sw-diag-gate');
  if (!gate) return;

  var css = document.createElement('style');
  css.textContent = '#sw-diag-gate{cursor:pointer}'
    + '#sw-diag-gate input,#sw-diag-gate button,#sw-diag-gate a{cursor:auto}'
    + '#sw-diag-gate button{cursor:pointer}';
  document.head.appendChild(css);

  gate.addEventListener('click', function (e) {
    var t = e.target;
    if (!t || !t.closest) return;
    if (t.closest('input, button, a, textarea, select, label')) return;

    var ids = ['sw-gate-name', 'sw-gate-phone', 'sw-gate-email'];
    var first = null;
    for (var i = 0; i < ids.length; i++) {
      var el = document.getElementById(ids[i]);
      if (el && !String(el.value || '').trim()) { first = el; break; }
    }
    var go = document.getElementById('sw-gate-go');

    try {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({ event: 'gate_text_click_rescued', page_path: location.pathname });
      if (typeof gtag === 'function') gtag('event', 'gate_text_click_rescued', { page_path: location.pathname });
      if (typeof clarity === 'function') clarity('event', 'gate_text_click_rescued');
    } catch (err) {}

    if (first && first.focus) { try { first.focus({ preventScroll: true }); } catch (err) { first.focus(); } }
    if (go && go.scrollIntoView) go.scrollIntoView({ behavior: 'smooth', block: 'center' });
  });
})();

/* V305 · 01.10.2026 — הקובץ נטען defer (V280). לחיצות שקרו לפני שהוא נטען נאספו בסניפט — עכשיו מבצעים אותן. */
window.__swCoreReady = true;
try { if (typeof window.__swCoreReplay === 'function') window.__swCoreReplay(); } catch (e) {}
